import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Wrapper from "@/timvir/wrapper";
const MDXLayout = Wrapper;
import {Message} from "timvir/blocks";
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "@timvir/std"
    }), "\n", _jsx(Message, {
      variant: "warning",
      children: _jsx(_components.p, {
        children: "This module can not be imported!"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  return _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  });
}
